export default __webpack_public_path__ + "static/media/SAS Alert Tone 9.543b350a.mp3";